import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=6bfa9357&scoped=true"
import script from "./EditInfo.vue?vue&type=script&lang=js"
export * from "./EditInfo.vue?vue&type=script&lang=js"
import style0 from "./EditInfo.vue?vue&type=style&index=0&id=6bfa9357&prod&lang=scss&scoped=true"
import style1 from "./EditInfo.vue?vue&type=style&index=1&id=6bfa9357&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa9357",
  null
  
)

export default component.exports